import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ScriptToggleComponent } from '../script-toggle/script-toggle.component';

@Component({
  selector: 'lv-walk-step-id',
  templateUrl: 'walk-step-id.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [TranslateModule, ScriptToggleComponent]
})
export class WalkStepIDComponent {}
